(() => {
  if (window.naxosFilterPanelsInitialized) return;
  window.naxosFilterPanelsInitialized = true;
  const selector = '[data-naxos-product-filter-section]';
  const instances = new WeakMap();
  function syncScrollLock() {
    document.documentElement.classList.toggle(
      'naxos-filter-dialog-open',
      Boolean(document.querySelector('[data-naxos-filter-dialog][open]'))
    );
  }

  function init(root) {
    if (instances.has(root)) return;
    const toggle = root.querySelector('[data-naxos-filter-toggle]');
    const dialog = root.querySelector('[data-naxos-filter-dialog]');
    const body = dialog?.querySelector('[data-naxos-filter-dialog-body]');
    const filters = root.querySelector('.naxos-products__filters');
    const panel = filters?.querySelector('.naxos-products__filter-panel');
    if (!toggle || !dialog || !body || !panel) return;

    const controller = new AbortController();
    const { signal } = controller;
    let backdropPressed = false;
    let swipe = null;

    function resetSwipe() {
      swipe = null;
    }

    function canSwipeOpen() {
      return toggle.getClientRects().length > 0 &&
        !document.querySelector('dialog[open]') &&
        !(window.visualViewport?.scale > 1);
    }

    function restore() {
      filters.append(panel);
      toggle.setAttribute('aria-expanded', 'false');
      syncScrollLock();
    }

    function close() {
      if (!dialog.open) return;
      dialog.close();
      restore();
      if (toggle.getClientRects().length) toggle.focus({ preventScroll: true });
    }

    function open() {
      if (dialog.open) return;
      resetSwipe();
      body.append(panel);
      dialog.showModal();
      body.scrollTop = 0;
      toggle.setAttribute('aria-expanded', 'true');
      syncScrollLock();
    }

    function trackSwipe(event) {
      if (!swipe) return;
      const touch = event.touches[0];
      if (event.touches.length !== 1 || touch.identifier !== swipe.id || !canSwipeOpen()) {
        resetSwipe();
        return;
      }
      const distance = swipe.x - touch.clientX;
      const vertical = Math.abs(touch.clientY - swipe.y);
      if (distance < -8 || (vertical > 12 && vertical >= distance)) {
        resetSwipe();
        return;
      }
      if (distance > 8 && distance >= vertical * 2) {
        if (event.cancelable) event.preventDefault();
        swipe.claimed = true;
      }
    }

    toggle.addEventListener('click', open, { signal });
    document.addEventListener('touchstart', (event) => {
      resetSwipe();
      if (event.touches.length !== 1 || !canSwipeOpen() || event.defaultPrevented) return;
      if (event.target.closest?.('input, textarea, select, [contenteditable], [role="slider"]')) return;
      const touch = event.touches[0];
      const width = document.documentElement.clientWidth;
      const bounds = root.getBoundingClientRect();
      if (touch.clientX < width - 40 || touch.clientX > width ||
          touch.clientY < bounds.top || touch.clientY > bounds.bottom) return;
      swipe = { id: touch.identifier, x: touch.clientX, y: touch.clientY, started: event.timeStamp, claimed: false };
    }, { passive: true, signal });
    document.addEventListener('touchmove', trackSwipe, { passive: false, signal });
    document.addEventListener('touchend', (event) => {
      const gesture = swipe;
      resetSwipe();
      if (!gesture?.claimed || event.touches.length || !canSwipeOpen()) return;
      const touch = Array.from(event.changedTouches).find((point) => point.identifier === gesture.id);
      if (!touch) return;
      const distance = gesture.x - touch.clientX;
      if (distance >= 64 && distance >= Math.abs(touch.clientY - gesture.y) * 2 &&
          event.timeStamp - gesture.started <= 1000) open();
    }, { passive: true, signal });
    document.addEventListener('touchcancel', resetSwipe, { passive: true, signal });

    dialog.addEventListener('close', () => {
      if (!dialog.open) restore();
    }, { signal });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    }, { signal });
    dialog.addEventListener('pointerdown', (event) => {
      const bounds = dialog.getBoundingClientRect();
      backdropPressed = event.target === dialog && (
        event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom
      );
    }, { signal });
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-naxos-filter-close], [data-naxos-filter-apply]') ||
          (event.target === dialog && backdropPressed)) close();
      backdropPressed = false;
    }, { signal });
    dialog.addEventListener('submit', (event) => {
      if (!event.target.matches('[data-naxos-filter-form]')) return;
      event.preventDefault();
      close();
    }, { signal });
    window.addEventListener('resize', () => {
      resetSwipe();
      if (dialog.open && !toggle.getClientRects().length) close();
    }, { signal });

    instances.set(root, () => {
      resetSwipe();
      controller.abort();
      if (dialog.open) dialog.close();
      restore();
      instances.delete(root);
    });
  }

  function rootsWithin(scope) {
    const roots = Array.from(scope.querySelectorAll(selector));
    if (scope.matches?.(selector)) roots.unshift(scope);
    return roots;
  }

  function initAll(scope) { rootsWithin(scope).forEach(init); }
  initAll(document);
  document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsWithin(event.target).forEach((root) => instances.get(root)?.());
  });
})();
